import type {
  OnboardingStepValue,
  ParsedOnboardingStep,
  TourId,
} from "@/features/onboarding/types/tour.types"
import { fetchUserAttributes, updateUserAttribute } from "aws-amplify/auth"

export const getIsUserOnboarded = async (): Promise<boolean> => {
  const userAttributes = await fetchUserAttributes()
  const isOnboardedAttribute = userAttributes["custom:isOnboarded"] === "true"
  return isOnboardedAttribute
}

export const completeOnboarding = async (): Promise<void> => {
  await updateUserAttribute({
    userAttribute: {
      attributeKey: "custom:isOnboarded",
      value: "true",
    },
  })
}

// Get onboarding step from Cognito (e.g., "questionnaire:3", "completed", "skipped", or null)
export const getOnboardingStep = async (): Promise<OnboardingStepValue> => {
  const userAttributes = await fetchUserAttributes()
  const step = userAttributes["custom:onboardingStep"]
  return (step as OnboardingStepValue) || null
}

// Update onboarding step in Cognito
export const updateOnboardingStep = async (step: string): Promise<void> => {
  await updateUserAttribute({
    userAttribute: {
      attributeKey: "custom:onboardingStep",
      value: step,
    },
  })
}

// Parse step string "questionnaire:3" → { tourId: "questionnaire", step: 3 }
export const parseOnboardingStep = (
  stepValue: string,
): ParsedOnboardingStep | null => {
  if (!stepValue || stepValue === "completed" || stepValue === "skipped") {
    return null
  }
  const [tourId, stepStr] = stepValue.split(":")
  const step = parseInt(stepStr, 10)
  if (!tourId || isNaN(step)) {
    return null
  }
  return { tourId: tourId as TourId, step }
}

// Format step object → "questionnaire:3"
export const formatOnboardingStep = (tourId: TourId, step: number): string => {
  return `${tourId}:${step}`
}
